module.exports = __webpack_public_path__ + "img/dhht-4.4fc3c516.png";